<div class="date-picker" [formGroup]="formGroup">
  <div class="date-picker-input">
    <input
      type="text"
      class="form-control border-gray picker-input"
      ngbDatepicker
      formControlName="datePicker"
      #datePicker="ngbDatepicker"
      placeholder="ZZ.LL.AAAA"
      (dateSelect)="onDateChanged($event)"
      (blur)="onDateInputChange($event)"
      [ngClass]="{ 'is-invalid': (submitted && picker.errors) || !validDate || invalid }"
      [readonly]="disabled"
    />
    <div
      *ngIf="formGroup.touched && !disabled"
      class="date-picker-reset"
      (click)="resetDatePicker()"
    >
      <i class="mdi mdi-close"></i>
    </div>
  </div>

  <div
    class="date-picker-button"
    (click)="datePicker.toggle()"
    [ngClass]="{ 'disabled': disabled }"
  >
    <i class="mdi mdi-calendar-range"></i>
  </div>
</div>
<div
  *ngIf="submitted && picker.errors"
  class="invalid-feedback"
  [ngClass]="{ 'd-block': submitted && picker.errors }"
>
  <div *ngIf="picker.errors.required">
    Completarea acestui câmp este obligatorie.
  </div>
</div>
<div
  *ngIf="!validDate"
  class="invalid-feedback"
  [ngClass]="{ 'd-block': !validDate }"
>
  <div *ngIf="!validDate">
    Data introdusă nu este validă.
  </div>
</div>
